export default "__VITE_ASSET__CE_7SoiB__"